import { dateOrNull } from "../../../index";

interface ScheduledChangeProps {
	action: ScheduledChangeAction;
	effectiveAt: Date | null;
	resumeAt: Date | null;
}

class ScheduledChange {
	constructor(private _: ScheduledChangeProps) {}

	static fromJson(scheduledChange: any) {
		return new ScheduledChange({
			action: scheduledChange?.action,
			effectiveAt: dateOrNull(scheduledChange?.effective_at),
			resumeAt: dateOrNull(scheduledChange?.resume_at),
		});
	}

	toJson() {
		return {
			action: this._.action,
			effective_at: this._.effectiveAt,
			resume_at: this._.resumeAt,
		};
	}

	displayText() {
		if (this._.action === ScheduledChangeAction.CANCEL) {
			return `Cancellation scheduled for ${this._.effectiveAt?.toLocaleDateString()}`;
		} else if (this._.action === ScheduledChangeAction.PAUSE) {
			return `Pause scheduled for ${this._.effectiveAt?.toLocaleDateString()}`;
		} else if (this._.action === ScheduledChangeAction.RESUME) {
			return `Resume scheduled for ${this._.effectiveAt?.toLocaleDateString()}`;
		} else {
			return "";
		}
	}
}

enum ScheduledChangeAction {
	CANCEL = "cancel",
	PAUSE = "pause",
	RESUME = "resume",
}

export { ScheduledChange, ScheduledChangeAction };
